import './CircleGraph.scss'
import template from './CircleGraph.vhtml';

export default {
	name: 'CircleGraph',
	template: template,
	props: {
		color: {
			type: String,
			default: '#D6D0C1',
		},
		segments: {
			type   : Array,
			default: () => [
				{
					color: '#C9694B',
					percent: 100,
				}
			],
		}
	},
	data: () => ({}),
	computed: {},
	methods: {
		calcSegment( percent ) {
			const leftOver = 100 - percent;
			return `${percent} ${leftOver}`;
		}
	},
};
